<template>
  <div class="reset-wrp">
    <FormList
      :list="userInfoList"
      :data="editData"
      :onChange="onInputChange"
      :onBlur="onBlur"
      :onFocus="onFocus"
    />
    <div class="code-wrp">
      <FormList
        :list="codeList"
        :data="editData"
        :onChange="onInputChange"
        :onBlur="onBlur"
        :onFocus="onFocus"
      />
      <van-button class="get-code" plain type="info" @click="canClick ? getResetTestCode() : null">{{buttonTitle}}</van-button>
    </div>
    <FormList
      :list="passList"
      :data="editData"
      :onChange="onInputChange"
      :onBlur="onBlur"
      :onFocus="onFocus"
    />
    <ButtonRow
      :firstClick="cancel"
      :secondClick="confirmChange"
      secondText="确 定"
      :loading="loading"
      :bottom="true"
      :borderRadius="true"
    />
  </div>
</template>

<script>
import {
  Row,
  Field,
  CellGroup,
  Button,
  Notify
} from 'vant'
import { accountRequest } from '@services'
import { localStorage } from '@utils/basicUtil'
import ButtonRow from '@components/ButtonRow'
import FormList from '@components/FormList'
export default {
  data () {
    return {
      editData: {
        phone: '',
        checkCode: '',
        password: '',
        rePassword: ''
      },
      isPhone: false,
      account: '',
      buttonTitle: '获取验证码',
      canClick: true,
      timer: null,
      loading: false,
      userInfoList: [
        {
          type: 'text',
          field: 'phone',
          label: '手机账号',
          placeholder: '请输入手机账号'
        }
      ],
      codeList: [
        {
          type: 'text',
          field: 'checkCode',
          label: '短信验证',
          placeholder: '请输入短信验证'
        }
      ],
      passList: [
        {
          type: 'password',
          field: 'password',
          label: '密码',
          placeholder: '请输入密码'
        },
        {
          type: 'password',
          field: 'rePassword',
          label: '确认密码',
          placeholder: '请输入确认密码'
        }
      ]
    }
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    onInputChange ({ e, field }) {
      this.editData = {
        ...this.editData,
        [field]: e
      }
    },
    onBlur ({ e, field }) {
      if (field === 'purchaserName') {
      }
    },
    onFocus ({ e, field }) {
      if (field === 'purchaserName') {
      }
    },
    cancel () {
      this.$router.go(-1)
    },
    testPhone () {
      if (!/^1[34578]\d{9}$/.test(this.editData.phone.trim())) {
        Notify({ type: 'danger', message: '手机号格式不正确' })
      } else {
        this.isPhone = true
      }
    },
    testCodeTime () {
      let timeDown = 60
      this.timer = setInterval(() => {
        if (timeDown === 0) {
          clearInterval(this.timer)
          this.canClick = true
          this.buttonTitle = '发送验证码'
        } else {
          this.buttonTitle = timeDown + '秒后重试'
          this.canClick = false
          timeDown--
        }
      }, 1000)
    },
    async getResetTestCode () {
      this.testPhone()
      if (this.isPhone === true) {
        const res = await accountRequest.reset.inspectPhone({ account: this.editData.phone })
        console.log(res)
        if (res.success) {
          this.account = res.result
        } else {
          return Notify({ type: 'danger', message: res.message })
        }
        this.testCodeTime()
        const data = await accountRequest.reset.getCheckCode({
          phone: this.editData.phone,
          businessType: 'RESET_PASSWORD',
          captchaLength: 4
        })

        if (data.success) {
          Notify({ type: 'success', message: '验证码已发送' })
        } else {
          clearInterval(this.timer)
          this.canClick = true
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    checkPassword () {
      if (this.editData.password.trim().length === 0) {
        Notify({ type: 'danger', message: '请输入密码' })
        return false
      }
      if (this.editData.rePassword.trim().length === 0) {
        Notify({ type: 'danger', message: '请确认密码' })
        return false
      }
      if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/.test(this.editData.password)) {
        Notify({ type: 'danger', message: '密码格式不正确' })
        return false
      }
      if (this.editData.password !== this.editData.rePassword) {
        Notify({ type: 'danger', message: '两次输入密码不一致' })
        return false
      }
      return true
    },
    async confirmChange () {
      if (this.checkPassword() === false) {
        return
      }
      const data = await accountRequest.reset.resetPassword({
        name: this.account,
        code: this.editData.checkCode,
        password: this.editData.password,
        phone: this.editData.phone
      })
      if (data.success) {
        Notify({ type: 'success', message: '密码修改成功' })
        localStorage.delete('X-Access-Token')
        localStorage.delete('X-C-Token')
        this.$router.push(`/user/login`)
      } else {
        return Notify({ type: 'danger', message: data.result.message })
      }
    }
  },
  components: {
    ButtonRow,
    [Row.name]: Row,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    FormList
  }
}
</script>

<style lang="less" scoped>
  .reset-wrp {
    width: 100%;
    min-height: 100%;
    background: #fff;
    box-sizing: border-box;
    padding-top: 15px;

    .input-field-wrapper+.input-field-wrapper {
      border-top: solid 1Px #edf2f6;
    }
    /deep/.van-field {
      padding: 25px 30px;
    }
    /deep/.van-cell--required::before {
      color: #4573DE;
    }

    .van-field__label,
    /deep/.van-field__label {
      width: 200px;
      font-size:30px;
      font-weight:500;
      color:rgba(51,51,51,1);
    }
    /deep/ .van-field__control {
      color: #999;
      text-align: right;
    }
    .code-wrp{
      position: relative;
      border-top: 1PX solid #edf2f6;
      border-bottom: 1PX solid #edf2f6;
      box-sizing: border-box;
    }
    .get-code {
      width: 180px;
      height: 54px;
      font-size: 24px;
      border-radius: 5px;
      position: absolute;
      left: 40%;
      top: 50%;
      transform: translateY(-50%);
      border: 0;
    }

  }
</style>
